import React from 'react';
import '../../assets/Css/aos.css'
import '../../assets/Css/bootstrap.min.css'
import '../../assets/Css/fontawesome.css'
import '../../assets/Css/magnific-popup.css'
import '../../assets/Css/main.css'
import '../../assets/Css/mobile-menu.css'
import '../../assets/Css/nice-select.css'
import '../../assets/Css/owl.carousel.min.css'
import '../../assets/Css/slick-slider.css'
import Img1 from "../../img/demo/demo1.png"
import Img2 from "../../img/demo/demo2.png"
import Img3 from "../../img/demo/demo3.png"
import Img4 from "../../img/demo/demo4.png"
import HeaderImg from "../../img/logo/header-logo1.png"
import LoginImg from "../../img/icons/login.png"
import { useNavigate } from 'react-router-dom';
import { faAngleDown, faAngleRight, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


const Header = () => {

    const navigate = useNavigate();

    const handleNavigate = () => {
        navigate('/contact')
    }

    return (
        <>
            <div>

                <div className="header-area header-area1 header-area-all d-none d-lg-block" id="header">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <div className="header-elements">
                                    <div className="site-logo">
                                        <a onClick={() => navigate('/')}>
                                            <img src={HeaderImg} alt="" />
                                        </a>
                                    </div>

                                    <div className="main-menu-ex main-menu-ex1">
                                        <ul>
                                            <li><a href="#">Home <FontAwesomeIcon icon={faAngleDown} /></a>
                                                <div className="tp-submenu">
                                                    <div className="row">
                                                        <div className="col-lg-12">
                                                            <div className="all-images-menu">
                                                                <div className="homemenu-thumb">
                                                                    <div className="img1">
                                                                        <img src={Img1} alt="" />
                                                                    </div>
                                                                    <div className="homemenu-btn">
                                                                        <a className="header-btn1" href="/">Multi Page <FontAwesomeIcon icon={faArrowRight} transform={{ rotate: 315 }} /></a>
                                                                        <div className="space16"></div>
                                                                        <a className="header-btn1" onClick={() => navigate('/singlePage')} target="_blank">One page <FontAwesomeIcon icon={faArrowRight} transform={{ rotate: 315 }} /></a>
                                                                    </div>
                                                                </div>

                                                                <div className="homemenu-thumb">
                                                                    <div className="img1">
                                                                        <img src={Img2} alt="" />
                                                                    </div>
                                                                    <div className="homemenu-btn">
                                                                        {/* <a className="header-btn1" href="/homeMultipage">Multi Page <FontAwesomeIcon icon={faArrowRight} transform={{ rotate: 315 }} /></a> */}
                                                                        <a className="header-btn1" onClick={() => navigate("/homeMultipage")}>Multi Page <FontAwesomeIcon icon={faArrowRight} transform={{ rotate: 315 }} /></a>
                                                                        <div className="space16"></div>
                                                                        {/* <a className="header-btn1" href="/homeSinglePage" target="_blank">One page <FontAwesomeIcon icon={faArrowRight} transform={{ rotate: 315 }} /></a> */}
                                                                        <a className="header-btn1" onClick={() => navigate("/homeSinglePage")}>One page <FontAwesomeIcon icon={faArrowRight} transform={{ rotate: 315 }} /></a>
                                                                    </div>
                                                                </div>

                                                                <div className="homemenu-thumb">
                                                                    <div className="img1">
                                                                        <img src={Img3} alt="" />
                                                                    </div>
                                                                    <div className="homemenu-btn">
                                                                        {/* <a className="header-btn1" href="/home2MultiPage">Multi Page <FontAwesomeIcon icon={faArrowRight} transform={{ rotate: 315 }} /></a> */}
                                                                        <a className="header-btn1" href="/home2MultiPage">Multi Page <FontAwesomeIcon icon={faArrowRight} transform={{ rotate: 315 }} /></a>
                                                                        <div className="space16"></div>
                                                                        {/* <a className="header-btn1" href="/home2SinglePage" target="_blank">One page <FontAwesomeIcon icon={faArrowRight} transform={{ rotate: 315 }} /></a> */}
                                                                        <a className="header-btn1" onClick={() => navigate("/home2SinglePage")}>One page <FontAwesomeIcon icon={faArrowRight} transform={{ rotate: 315 }} /></a>
                                                                    </div>
                                                                </div>

                                                                <div className="homemenu-thumb" style={{ margin: 0 }}>
                                                                    <div className="img1">
                                                                        <img src={Img4} alt="" />
                                                                    </div>
                                                                    <div className="homemenu-btn">
                                                                        <a className="header-btn1" onClick={() => navigate("/homeIndexMultiPage")}>Multi Page <FontAwesomeIcon icon={faArrowRight} transform={{ rotate: 315 }} /></a>
                                                                        <div className="space16"></div>
                                                                        {/* <a className="header-btn1" href="single-/homeIndexMultiPage" target="_blank">One page <FontAwesomeIcon icon={faArrowRight} transform={{ rotate: 315 }} /></a> */}
                                                                        <a className="header-btn1" onClick={() => navigate("/homeIndexSinglePage")}>One page <FontAwesomeIcon icon={faArrowRight} transform={{ rotate: 315 }} /></a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>

                                            <li><a onClick={() => navigate('/about')}>About Us</a></li>

                                            <li className="dropdown-menu-parrent"><a href="#" className="main1">Market <FontAwesomeIcon icon={faAngleDown} /></a>
                                                <ul>
                                                    <li><a onClick={() => navigate('/market')}>Market Update</a></li>
                                                    <li><a onClick={()=>navigate('/buyCrypto')}>Buy Crypto</a></li>
                                                    <li><a href="/sellBuyCrypto">Sell Crypto</a></li>
                                                </ul>
                                            </li>

                                            <li className="dropdown-menu-parrent"><a href="#" className="main1">Pages <FontAwesomeIcon icon={faAngleDown} /></a>
                                                <ul>
                                                    <li><a href="/contact">Contact</a></li>
                                                    <li><a href="/faq">FAQ</a></li>
                                                    <li><a href="/error">404</a></li>
                                                </ul>
                                            </li>

                                            <li className="dropdown-menu-parrent"><a href="#" className="main1">Blog <FontAwesomeIcon icon={faAngleDown} /></a>
                                                <ul>
                                                    <li><a href="/blog">Blog</a></li>
                                                    <li className="has-dropdown has-dropdown1"><a href="/blogDetail" className="main">Blog Details<span><FontAwesomeIcon icon={faAngleRight} /></span></a>
                                                        <ul className="sub-menu">
                                                            <li><a href="/blogDetailLeft">Details Left</a></li>
                                                            <li><a href="/blogDetailRight">Details Right</a></li>
                                                            <li><a href="/blogDetail">Single Details</a></li>
                                                        </ul>
                                                    </li>   
                                                </ul>
                                            </li>

                                            <li className="dropdown-menu-parrent"><a href="#" className="main1">Account <FontAwesomeIcon icon={faAngleDown} /></a>
                                                <ul>
                                                    <li><a href="/user">My Profile</a></li>
                                                    <li><a onClick={() => navigate('/login')}>Login</a></li>
                                                    <li><a href="/register">Register</a></li>
                                                </ul>
                                            </li>
                                        </ul>
                                    </div>

                                    <div className="header2-buttons">
                                        <div className="button">
                                            <a className="login" onClick={() => navigate('/login')} style={{ cursor: "pointer" }}>Login <img src={LoginImg} alt="" /></a>
                                            <a className="theme-btn1 btn btn--ripple ripple" onClick={() => handleNavigate()} style={{ color: "white" }}>Get A Quote <FontAwesomeIcon icon={faArrowRight} transform={{ rotate: 315 }} style={{ marginLeft: "5px" }} /></a>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Header;
